import { useCallback } from 'react';
import { isEmpty } from 'lodash';
import { useGetMeasurementDatesByFund } from 'services/hooks/funds';
import { getObjectValue } from 'utilities';
import { GetMeasurementDatesHook, UseGetMeasurementDates } from './types';
import {FundMeasurementDate, MeasurementDateRolloverReturn} from '../../../../api';
import { FundMd } from '../useFundMeasurementDateFilter/types';

const useGetMeasurementDates: UseGetMeasurementDates = params => {
  const { activeFund, setSelectedMeasurementDate, openMeasurementDatesDialog } = params;

  const { data: measurementDates, refetch } = useGetMeasurementDatesByFund({
    fund: activeFund,
    shouldQueryAutomatically: !openMeasurementDatesDialog,
  });

  const getMeasurementDates = useCallback(
    async (newMeasurementDates: MeasurementDateRolloverReturn[]) => {
      await refetch();

      if (isEmpty(newMeasurementDates)) {
        return;
      }

      const getFundMd = (mds: FundMeasurementDate[]) => {
        if (activeFund?.id) {
          return mds.find(md => md.fund === activeFund.id) ?? mds?.[0];
        }
        return mds[0];
      };

      const filteredMDs = newMeasurementDates.filter(md => md.fund_mds);
      const flatFundMds = filteredMDs.flatMap(md => md.fund_mds) as FundMeasurementDate[];

      const recentMD =  (getFundMd(flatFundMds)).measurement_date;

      if (!isEmpty(recentMD)) {
        setSelectedMeasurementDate(recentMD);
      }
    },
    [refetch, setSelectedMeasurementDate, activeFund]
  );

  return {
    getMeasurementDates,
    measurementDates,
  };
};

export default useGetMeasurementDates;
